<template>
  <div class="row for-authors-submission">
    <!--Non-Mobile Only-->
    <div class="col-md-3 hidden-sm-down">
      <for-authors-page-side-menu :anchors-list="menuAnchorsList"></for-authors-page-side-menu>
    </div>
    <!--Non-Mobile Only-->
    <div class="col-md">
      <for-authors-submission-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[0].anchor"></for-authors-submission-content>
      <for-authors-file-submission-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[1].anchor"></for-authors-file-submission-content>
      <for-authors-special-submission-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[2].anchor"></for-authors-special-submission-content>
      <for-authors-revisions-submission-content :anchors-list="menuAnchorsList" :id="menuAnchorsList[3].anchor"></for-authors-revisions-submission-content>
    </div>
  </div>
</template>

<script>
  import ForAuthorsPageSideMenu from '@/components/for-authors/ForAuthorsPageSideMenu'
  import ForAuthorsSubmissionContent from '@/components/for-authors/for-authors-submission/ForAuthorsSubmissionContent'
  import ForAuthorsSpecialSubmissionContent from '@/components/for-authors/for-authors-submission/ForAuthorsSpecialSubmissionContent'
  import ForAuthorsRevisionsSubmissionContent from '@/components/for-authors/for-authors-submission/ForAuthorsRevisionsSubmissiomContent'
  import ForAuthorsFileSubmissionContent from '@/components/for-authors/for-authors-submission/ForAuthorsFileSubmissionContent'

  export default {
    components: {
      ForAuthorsPageSideMenu,
      ForAuthorsSubmissionContent,
      ForAuthorsSpecialSubmissionContent,
      ForAuthorsRevisionsSubmissionContent,
      ForAuthorsFileSubmissionContent
    },
    name: 'for-authors-submission',
    data () {
      return {
        menuAnchorsList: [
          {anchor: 'submission', name: 'Submission'},
          {anchor: 'files', name: 'Submission of Files'},
          {anchor: 'special', name: 'Special Submissions'},
          {anchor: 'revisions', name: 'Submitting Revisions'}
        ]
      }
    }
  }
</script>




// WEBPACK FOOTER //
// ForAuthorsSubmissionPage.vue?a64a8c14